<template>
  <div>
    <div class="overflow-hidden rounded-2xl border border-gray-900 w-full">
      <div class="grid grid-cols-12 ">
        <div class="laptop:col-span-7">
          <div class="flex items-center justify-between p-3 border-b !border-gray-300 bg-white">
            <div class="flex items-center gap-2">
              <img src="../../assets/images/dashboard-calendar-icon.png" alt="Calendar Icon"
                class="w-10 h-10 object-cover">
              <div>
                <h3 class="m-0 text-[20px] font-roboto font-medium text-purple-900">March 26, 2025</h3>
                <p class="m-0 text-[14px] font-roboto font-medium text-gray-600">Wednesday</p>
              </div>
            </div>
            <p class="m-0">You have 7 activities</p>
          </div>
          <div class="p-2">
            <div v-if="true" class="max-h-[420px] overflow-y-scroll customScrollbar pr-2">
              <customTable :headers="tableHeaders" :items="tableItems" />
            </div>
            <div v-else>
              <h2 class="m-0 font-medium font-roboto text-[40px] text-center text-gray-500">No Activities Today
              </h2>
            </div>
          </div>
        </div>
        <div class="laptop:col-span-5">
          <customCalendar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import globalDashboardHead from "../../components/globaldashboardHead.vue"
// import welcomeCard from "../../components/welcomeCard.vue";
// import sidebarNavigation from '../../components/sidebarNavigation.vue';
import customCalendar from '../../components/partialComponent/customCalendar.vue';
import customTable from "../../components/partialComponent/customTable.vue";
import nrgLogo from "../../assets/images/nrg-logo.png"

export default {
  components: {
    // globalDashboardHead,
    // welcomeCard,
    // sidebarNavigation,
    customTable,
    customCalendar,
  },
  data() {
    return {
      tableHeaders: [
        { key: 'id', text: 'ID' },
        { key: 'customerName', text: 'Consumer Name' },
        { key: 'servicetype', text: 'Service Type' },
        { key: 'date', text: 'Date' },
        { key: 'textStatus', text: 'Status' },
        { key: 'image', text: 'Partners' },
      ],
      tableItems: [
        {
          id: 27854,
          customerName: 'Celica Jamson',
          servicetype: 'Service And Repair',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Evaluation Completed',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'Celica Jamson',
          servicetype: 'Replacement Quote',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Inspection Started',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'John Steven',
          servicetype: 'Replacement Quote',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Inspection Started',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'Celica Jamson',
          servicetype: 'Service And Repair',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Evaluation Completed',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'Celica Jamson',
          servicetype: 'Replacement Quote',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Inspection Started',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'John Steven',
          servicetype: 'Replacement Quote',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Inspection Started',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'Celica Jamson',
          servicetype: 'Service And Repair',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Evaluation Completed',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'Celica Jamson',
          servicetype: 'Replacement Quote',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Inspection Started',
          image: nrgLogo,
        },
        {
          id: 27854,
          customerName: 'John Steven',
          servicetype: 'Replacement Quote',
          date: '03/17/2025 03:00 AM',
          textStatus: 'Inspection Started',
          image: nrgLogo,
        },
      ]
    }
  },
};
</script>
